export interface FaceParams {
  tokenUrl: string;
  validationUrl: string;
  process: string;
  attempt: number;
  applicationId: string;
  xFlowSessionId?: string;
  identificationType: string;
  identificationNumber: string;
  appSessionId: string;
  isDev?: boolean;
}

export enum FaceIdErrors {
  TIMEOUT = 'timeout',
  RETRY = 'retry'
}

export enum FaceCode {
  ok = '8000', // Todas las operaciones se efectuaron correctamente
  invalid = '8166', // Se encontró datos inválidos o requeridos
  existingContract = '8057', // Ya existe un contrato con el numero de cuenta ingresado
  applicationNotFound = '8102', // Solicitud del proceso no encontrada
  deniedApplication = '8367', // La operación no corresponde al flujo configurado para el cliente.
  unsavedDocument = '8096', // No fue posible guardar documento
  intermittence = '8163', // Error al actualizar datos por intermitencia
  biometricError = '8003', // Ocurrió un error en motor biométrico
  errorService = '8087' // Excepción al consumir servicio feignclient
 }
